import { render, staticRenderFns } from "./FueraPlazo.vue?vue&type=template&id=64b6f406"
import script from "./FueraPlazo.vue?vue&type=script&lang=js"
export * from "./FueraPlazo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports